import { useState } from "react";
import { useHistory } from "react-router-dom";

import Header from "../components/Header";
import Footer from "../components/Footer";

function CreateListing() {
  const history = useHistory();

  const [name, setName] = useState("");
  const [price, setPrice] = useState("");
  const [category, setCategory] = useState("Հեռախոսներ");
  const [phone, setPhone] = useState("");
  const [email, setEmail] = useState("");
  const [description, setDescription] = useState("");
  const [image, setImage] = useState("");

  const handleImageChange = (e) => {
    const file = e.target.files[0];

    if (!file) return;

    if (!file.type.startsWith("image/")) {
      alert("Խնդրում ենք ընտրել նկար։");
      return;
    }

    if (file.size > 5 * 1024 * 1024) {
      alert("Նկարի չափը չպետք է գերազանցի 5MB-ը։");
      return;
    }

    const reader = new FileReader();

    reader.onloadend = () => {
      setImage(reader.result);
    };

    reader.readAsDataURL(file);
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const token = localStorage.getItem("token");

    if (!token) {
      alert(
        "Հայտարարություն տեղադրելու համար մուտք գործեք։"
      );

      history.push("/login");
      return;
    }

    let userId = null;

    try {
      const payload = JSON.parse(
        atob(token.split(".")[1])
      );

      userId = payload.id;
    } catch (error) {
      console.error("Token error:", error);

      alert("Մուտքի տվյալները սխալ են։");
      return;
    }

    const newListing = {
      id: Date.now(),
      userId,

      name: name.trim(),

      price: `${price} ֏`,

      category,

      phone: phone.trim(),

      email: email.trim(),

      description: description.trim(),

      image:
        image ||
        "https://images.unsplash.com/photo-1523275335684-37898b6baf30?w=800",

      status: "pending",

      rejectionReason: "",
    };

    try {
      const existing =
        JSON.parse(
          localStorage.getItem("buySellListings")
        ) || [];

      const updated = [
        ...existing,
        newListing,
      ];

      localStorage.setItem(
        "buySellListings",
        JSON.stringify(updated)
      );

      alert(
        "Հայտարարությունը հաջողությամբ ուղարկվեց ադմինին։"
      );

      history.push("/my-listings");
    } catch (error) {
      console.error("SAVE ERROR:", error);

      alert(
        "Հայտարարությունը պահպանել չհաջողվեց։"
      );
    }
  };

  return (
    <>
      <Header />

      <main className="create-listing-page">

        <div className="container">

          <div className="create-listing-layout">

            {/* Ձախ հատված */}

            <div className="create-listing-info">

              <div className="create-badge">
                <span>+</span>
                ՆՈՐ ՀԱՅՏԱՐԱՐՈՒԹՅՈՒՆ
              </div>

              <h1>
                Վաճառիր այն,
                <br />
                ինչն այլևս
                <br />
                <span>պետք չէ։</span>
              </h1>

              <p>
                Տեղադրիր քո ապրանքը, ներկայացրու
                մանրամասները և գտիր գնորդին։
              </p>

              <div className="listing-benefits">

                <div className="listing-benefit">
                  <div className="benefit-icon">
                    ✓
                  </div>

                  <div>
                    <strong>
                      Արագ տեղադրում
                    </strong>

                    <span>
                      Հայտարարությունը լրացրու
                      մի քանի րոպեում
                    </span>
                  </div>
                </div>

                <div className="listing-benefit">
                  <div className="benefit-icon">
                    ✓
                  </div>

                  <div>
                    <strong>
                      Անվտանգ հրապարակում
                    </strong>

                    <span>
                      Յուրաքանչյուր հայտարարություն
                      ստուգվում է ադմինի կողմից
                    </span>
                  </div>
                </div>

                <div className="listing-benefit">
                  <div className="benefit-icon">
                    ✓
                  </div>

                  <div>
                    <strong>
                      Ավելի շատ գնորդներ
                    </strong>

                    <span>
                      Քո ապրանքը հասանելի կլինի
                      marketplace-ի օգտատերերին
                    </span>
                  </div>
                </div>

              </div>

            </div>


            {/* Ձև */}

            <div className="listing-form-card">

              <div className="form-card-header">

                <div className="form-card-icon">
                  📦
                </div>

                <div>
                  <h2>
                    Տեղադրել հայտարարություն
                  </h2>

                  <p>
                    Լրացրեք ապրանքի տվյալները
                  </p>
                </div>

              </div>


              <form
                onSubmit={handleSubmit}
                className="listing-form"
              >

                {/* Անուն */}

                <div className="form-group full-width">

                  <label>
                    Ապրանքի անուն
                    <span>*</span>
                  </label>

                  <input
                    type="text"
                    placeholder="Օրինակ՝ iPhone 15 Pro"
                    value={name}
                    onChange={(e) =>
                      setName(e.target.value)
                    }
                    required
                  />

                </div>


                {/* Գին + կատեգորիա */}

                <div className="form-row">

                  <div className="form-group">

                    <label>
                      Գին
                      <span>*</span>
                    </label>

                    <div className="price-input">

                      <input
                        type="number"
                        placeholder="350000"
                        min="0"
                        value={price}
                        onChange={(e) =>
                          setPrice(e.target.value)
                        }
                        required
                      />

                      <span>֏</span>
                      <span>$</span>

                    </div>

                  </div>


                  <div className="form-group">

                    <label>
                      Կատեգորիա
                      <span>*</span>
                    </label>

                    <select
                      value={category}
                      onChange={(e) =>
                        setCategory(e.target.value)
                      }
                    >
                      <option>
                        Հեռախոսներ
                      </option>

                      <option>
                        Անշարժ գույք
                      </option>


                      <option>
                        Համակարգիչներ
                      </option>

                      <option>
                        Հագուստ
                      </option>

                      <option>
                        Կահույք
                      </option>

                      <option>
                        Մեքենաներ
                      </option>

                      <option>
                        Այլ
                      </option>
                    </select>

                  </div>

                </div>


                {/* Հեռախոս + email */}

                <div className="form-row">

                  <div className="form-group">

                    <label>
                      Հեռախոսահամար
                      <span>*</span>
                    </label>

                    <input
                      type="tel"
                      placeholder="091 123 456"
                      value={phone}
                      onChange={(e) =>
                        setPhone(e.target.value)
                      }
                      required
                    />

                  </div>


                  <div className="form-group">

                    <label>
                      Էլ․ փոստ
                      <span>*</span>
                    </label>

                    <input
                      type="email"
                      placeholder="example@gmail.com"
                      value={email}
                      onChange={(e) =>
                        setEmail(e.target.value)
                      }
                      required
                    />

                  </div>

                </div>


                {/* Նկար */}

                <div className="form-group full-width">

                  <label>
                    Ապրանքի նկար
                  </label>

                  <label
                    htmlFor="listing-image"
                    className="image-upload"
                  >

                    <div className="upload-icon">
                      ↑
                    </div>

                    <div>
                      <strong>
                        Սեղմեք նկարը ավելացնելու համար
                      </strong>

                      <span>
                        PNG, JPG կամ WEBP • մինչև 5MB
                      </span>
                    </div>

                  </label>

                  <input
                    id="listing-image"
                    type="file"
                    accept="image/*"
                    onChange={handleImageChange}
                    className="hidden-file-input"
                  />

                </div>


                {/* Preview */}

                {image && (
                  <div className="image-preview-wrapper">

                    <div className="preview-header">
                      <span>
                        Նկարի նախադիտում
                      </span>

                      <button
                        type="button"
                        onClick={() => setImage("")}
                      >
                        Հեռացնել
                      </button>
                    </div>

                    <img
                      src={image}
                      alt="Preview"
                      className="listing-image-preview"
                    />

                  </div>
                )}


                {/* Նկարագրություն */}

                <div className="form-group full-width">

                  <label>
                    Նկարագրություն
                    <span>*</span>
                  </label>

                  <textarea
                    rows="6"
                    placeholder="Գրեք ապրանքի մասին, նշեք վիճակը, օգտագործման ժամկետը, առանձնահատկությունները և այլ կարևոր տեղեկություններ..."
                    value={description}
                    onChange={(e) =>
                      setDescription(
                        e.target.value
                      )
                    }
                    required
                  />

                  <div className="textarea-hint">
                    Որքան մանրամասն լինի
                    նկարագրությունը, այնքան ավելի
                    հեշտ կլինի գնորդին կողմնորոշվել։
                  </div>

                </div>


                {/* Submit */}

                <button
                  type="submit"
                  className="publish-listing"
                >
                  <span>
                    Տեղադրել հայտարարությունը
                  </span>

                  <strong>
                    →
                  </strong>
                </button>

                <p className="form-bottom-note">
                  Հայտարարությունը նախ կստուգվի
                  ադմինի կողմից, ապա կհրապարակվի։
                </p>

              </form>

            </div>

          </div>

        </div>

      </main>

      <Footer />
    </>
  );
}

export default CreateListing;